import React,{useState} from "react";
import Footer from "../inc/Footer";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import axios from 'axios';
import '../inc/GlobalVars';
import { ToastContainer, toast } from 'react-toastify';
function ForgotPassword() {
  const iconsStyles = {
     padding:"10px",lineHeight:"75px",
    margin:"0 auto",borderRadius:"50%",minHeight:"100px",maxHeight:"130px",minWidth:"100px",maxWidth:"100px",display:"block"
  };


  const [email, setEmail] = useState("");

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(global.apiUrl +"/forgotPassword", { email });

      if (response.status === 200) {
        // Display success toast
        toast.success("Reset email sent to your email ID.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });

        // Reset the email field
        setEmail("");
      } else {
        toast.error("Failed to send reset email. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred. Please try again later.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
    }
  };
  return (
    <div>
     <ToastContainer
position="top-left"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="colored"
/>
      <div className="container mb-3 mt-5 mb-5">

        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-6">
          <form
      className="forgotPasswordForm"
      role="form"
      method="post"
      encType="multipart/form-data"
      onSubmit={handleSubmit}
    >
      <label>
        Email ID <span className="text-danger">*</span>
      </label>
      <input
        type="email"
        name="email"
        placeholder="Enter Registered Email ID"
        className="form-control"
        value={email}
        onChange={handleInputChange}
        required
      />
      <button className="btn btn-primary contactButton mt-3" type="submit">
        Send Reset Link
      </button>
    </form>
          </div>
          
                    
        </div>

        

       


       

        
      </div>
      
      <Footer />
    </div>
  );
}

export default ForgotPassword;
